import * as React from "react";
import { Menu } from 'semantic-ui-react'
import { Link } from 'react-router-dom';
import * as routes from "../constants/routes";
import { AuthUserContext } from "../firebase/AuthUserContext";



export const MenuVertical = () => (
    <AuthUserContext.Consumer>
    { authUser => (authUser && 
        <Menu inverted fixed="left" style={{ marginTop : '50px' , paddingTop : '10px'}} vertical size="large">
            <Menu.Item  as={Link} to={routes.HOME} name='Home'/>
            <Menu.Item  as={Link} to={routes.CATEGORIES} name='Categories'/>
            <Menu.Item  as={Link} to={routes.USERS} name='Users'/>
            <Menu.Item  as={Link} to={routes.TAGS} name='Tags'/>
        </Menu>
    )}
    </AuthUserContext.Consumer>
  )




// WEBPACK FOOTER //
// ./src/components/Menu.tsx